(function($, psw) {
    'use strict';

    const euro_countries = ['AT', 'BE', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LV', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES'];
    const currencySymbols = {
        usd_price: {
            formatter: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', trailingZeroDisplay: "stripIfInteger"}),
            text: 'US Dollars'
        },
        euro_price: {
            formatter: new Intl.NumberFormat('en-DE', {style: 'currency', currency: 'EUR', trailingZeroDisplay: "stripIfInteger"}),
            text: 'Euros'
        }
    };

    async function priceSelector() {
        let priceSelected = localStorage.currency_selector || psw.currency.defaultPrice;

        if (localStorage.currency_selector) {
            return { priceSelected, currency: currencySymbols[priceSelected] };
        }

        try {
            const response = await $.ajax({
                url: 'https://ipinfo.io/?token=ae2eda199e70fa',
                method: 'get',
                timeout: '2000',
                jsonp: true
            });

            if (euro_countries.indexOf(response.country) >= 0) {
                priceSelected = 'euro_price';
            }

            localStorage.setItem('currency_selector', priceSelected);
        }
        catch(_) {
            priceSelected = psw.currency.defaultPrice;
        }

        return { priceSelected, currency: currencySymbols[priceSelected] };
    }

    psw.currency = {};
    psw.currency.defaultPrice = "usd_price";
    psw.currency.defaultCurrency = currencySymbols.usd_price;
    psw.currency.priceSelector = priceSelector;
})(jQuery, window.psw);